import React from 'react';
import '../CreatePostControlInfoAbbrevs/CreatePostControlInfoAbbrevs.scss';
import * as PropertyBucket from '../../Properties/Properties';
import PopUp from '.././PopUp/PopUp';
import Input from '.././Input/Input';
import SelectCustom from '../SelectCustom/SelectCustom';
import WysiwygEditor from '../WysiwygEditor/WysiwygEditor';

const MAX_FINDING_TITLE_LENGTH = 10000;
const MAX_FINDING_DETAILS_LENGTH = 10000;
const MAX_RECOMMENDATION_TEXT_LENGTH = 10000;

// komponent odpowiada blokowi
// jeśli w info pokontrolnej są 3 bloki do uwzględnienia
// to utworzone zostaną 3 komponenty
class CreatePostControlInfoFindings extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			showPopup: false,
			classesFindingKind: [],
			recommInputAutofocus: false,
		};
		this.handleClosePopUp = this.handleClosePopUp.bind(this);
		this.findingKindRef = React.createRef();
	}

	isFindingEdit(finding) {
		return this.props.findingUnderEdit === finding && this.props.sectionUnderEdit === null;
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (this.props.findings !== nextProps.findings) {
			return true;
		}
		return this.state !== nextState;

	}

	handleClosePopUp() {
		this.setState({showPopup: false});
	}

	showPopup = (title, notification, type, onClickEvent) => {
		this.setState({
			showPopup: true,
			popUp: {title: title, notification: notification, type: type, onClickEvent: onClickEvent}
		})

	};

	setCorrectionTypeValues = (values, findingId, findingPseudoId) => {
		let newFindings = [...this.props.findings];
		newFindings.forEach((finding) => {
			if (findingId && (findingId === finding.id)) {
				finding.findingKind = values[0];
			}

			// New added findings dont have findingId, they use pseudoId instead
			if (findingPseudoId && (findingPseudoId === finding.pseudoId)) {
				finding.findingKind = values[0];
			}
		});
		this.props.onFindingsChange(newFindings, this.props.blockId);//info={this.state.infoData}
	};

	handleChangeFindingTitle = (findingId, findingPseudoId, newValue) => {
	let newFindings = [...this.props.findings];
		newFindings.forEach((finding) => {
			if (findingId && (findingId === finding.id)) {
				finding.title = newValue;
			}

			// New added findings dont have findingId, they use pseudoId instead
			if (findingPseudoId && (findingPseudoId === finding.pseudoId)) {
				finding.title = newValue;
			}
		});
		this.props.onFindingsChange(newFindings, this.props.blockId);
	};

	handleChangeFindingContent = (findingId, findingPseudoId, newValue) => {
		let newFindings = [...this.props.findings];
		newFindings.forEach((finding) => {
			if (findingId && (findingId === finding.id)) {
				finding.content = newValue;
			}

			// New added findings dont have findingId, they use pseudoId instead
			if (findingPseudoId && (findingPseudoId === finding.pseudoId)) {
				finding.content = newValue;
			}
		});
		this.props.onFindingsChange(newFindings, this.props.blockId);
	};

	changeIsFinancial = (findingId, findingPseudoId) => {
		let newFindings = [...this.props.findings];
		newFindings.forEach((finding) => {
			if (findingId && (findingId === finding.id)) {
				let newFinancial = finding.isFinancial === true ? false : true;
				finding.isFinancial = newFinancial;
				if (newFinancial === false) {
					finding.findingKind = null
				}
			}

			if ( findingPseudoId && (findingPseudoId === finding.pseudoId)) {
				let newFinancial = finding.isFinancial === true ? false : true;
				finding.isFinancial = newFinancial;
				if (newFinancial === false) {
					finding.findingKind = null
				}
			}
		});
		this.props.onFindingsChange(newFindings, this.props.blockId);
	};

	changeRecommendations = (findingId, recommendationId, newValue) => {
		let newFindings = [...this.props.findings];
		newFindings.forEach((finding) => {
			if (findingId === finding.id) {
				finding.recommendations.forEach((recommendation) => {
					if (recommendationId === recommendation.id || recommendationId === recommendation.pseudoId) {
						recommendation.recommendationText = newValue;
					}
				})
			}
		});
		this.props.onFindingsChange(newFindings, this.props.blockId);
	};

	addRecommendation = (finding) => {
		let recommendations = finding.recommendations;
		let newRecommendation = {
			pseudoId: Date.now(),
			recommendationText: ''
		};
		recommendations.push(newRecommendation);

		this.props.onFindingsChange(this.props.findings, this.props.blockId);
		this.setState({recommInputAutofocus: true})
	};

	deleteRecommendation = (findingId, id) => {
		let findings = [...this.props.findings];
		findings.forEach((finding) => {
			if (findingId === finding.id) {
				finding.recommendations.forEach((recommendation, index) => {
					if (id === recommendation.id || id === recommendation.pseudoId) {
						finding.recommendations.splice(index, 1)
					}
				})
			}
		});

		this.props.onFindingsChange(findings, this.props.blockId);
	};

	renderRecommendations = (recommendations, findingId, findingNumber, autofocus, findingKey) => {

		let recommendationsToRender = [];
		let cnt = 1;

		recommendations.sort((a, b) => a.id - b.id).forEach((recommendation, index) => {
				let id = recommendation.id ? recommendation.id : recommendation.pseudoId;
				recommendationsToRender.push(
					<>
						<div className='col-md-10'>
							<p className='font-weight-bold'>{`Zalecenie ${findingNumber + '.' + cnt}`}</p>
							<WysiwygEditor
								size={MAX_RECOMMENDATION_TEXT_LENGTH}
								value={recommendation.recommendationText}
								readOnly={!this.isFindingEdit(findingKey)}
								onChange={(e) => this.changeRecommendations(findingId, id, e.target.value)}
							/>
						</div>
						{this.isFindingEdit(findingKey) && <div className='col-md-10' style={{marginBottom: recommendations.length === index + 1 ? 0 : 16}}>
							<button
								className='btn cancel-btn'
								disabled={!this.isFindingEdit(findingKey)}
								onClick={() => {
									this.onDeleteRecommendationClick(findingId, id);
								}}
							>
								USUŃ<span className='sr-only'> zalecenie {findingNumber}.{cnt}</span>
							</button>
						</div>}
					</>);
				cnt += 1;
			}
		);
		return recommendationsToRender
	};

	// pojedyncze ustalenia/pytania dla bloku
	processFinding = (finding, index) => {
		const findingKey = `findingIndex_${finding.id}_${finding.pseudoId}`;
		
		let disabled = !finding.isFinancial || !this.isFindingEdit(findingKey);
		

		return (
			<div key={findingKey} className='single-finding-container'>
				<div className='my-3'>
					<div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px', alignItems: 'center'}}>
						<h4>{`Ustalenie nr ${index}`}</h4>
						<div>
							{!this.isFindingEdit(findingKey) && (<button class="btn save-btn"
								onClick={() => {
									this.props.setFindingUnderEdit(findingKey);
									this.props.makeFindingCopy(finding);
								}}
								disabled={!this.isFindingEdit(null)}>
								EDYTUJ USTALENIE <span className='sr-only'> ustalenie nr {index}</span>
							</button>)}
							<button disabled={!this.isFindingEdit(findingKey)} className='btn cancel-btn'
								onClick={() => 
									{
										this.onDeleteFindingClick(finding.id, finding.pseudoId);
									}
								}>USUŃ USTALENIE<span className='sr-only'> nr {index}</span>
							</button>
						</div>
					</div>
					
					<WysiwygEditor
						size={MAX_FINDING_TITLE_LENGTH}
						value={finding.title}
						readOnly={!this.isFindingEdit(findingKey)}
						onChange={(e) => {
							this.handleChangeFindingTitle(finding.id, finding.pseudoId, e.target.value)
						}}
					/>
					<label className='is-finantial-checkbox'>
						<input
							type='checkbox'
							checked={finding.isFinancial}
							onChange={() => this.changeIsFinancial(finding.id, finding.pseudoId )}
							name='is_financial'
							disabled={finding.corrections.filter(x => !x.toRemove).length > 0 || !this.isFindingEdit(findingKey)}
							id={'changeIsFinantialId' + index}
						/>
						<span className='check-label'>Ustalenie finansowe</span>
					</label>

					{this.renderFindingKindSelect(finding.findingKind === undefined || finding.findingKind === null ? '' : finding.findingKind.code + ' ' + finding.findingKind.name, disabled, finding.id, finding.pseudoId, index)}
					<p className='font-weight-bold mt-3'>Szczegóły ustalenia</p>
					<WysiwygEditor
						size={MAX_FINDING_DETAILS_LENGTH}
						value={finding.content || ''}
						readOnly={!this.isFindingEdit(findingKey)}
						onChange={(e) => this.handleChangeFindingContent(finding.id, finding.pseudoId, e.target.value)}
					/>
				</div>
				<div className='mt-3 mb-5'>
					<h5 className='my-3'>Zalecenia związane z ustaleniem nr {index}</h5>
					<div className='row recommendation-list-container'>
						<div className='col-md-9 inputs-btn-list__row'>
							{this.renderRecommendations(finding.recommendations, finding.id, index, this.state.recommInputAutofocus, findingKey)}
						</div>
						<div className='col-md-3 inputs-btn-list__btn-col'>
							<button className='btn save-btn add-recommendation-btn' disabled={!this.isFindingEdit(findingKey)} onClick={() => this.addRecommendation(finding)}>
								DODAJ ZALECENIE<span className='sr-only'> związane z ustaleniem nr {index}</span>
							</button>
						</div>
					</div>
				</div>


				{this.isFindingEdit(findingKey) &&
				(
					<div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px', margin: "8px 0px"}}>
						<button className="btn save-btn"
							disabled={!this.isFindingEdit(findingKey)}
							onClick={() => {
								this.props.saveFinding(finding.id, finding.pseudoId);
							}}>ZAPISZ <span className='sr-only'> ustalenie nr {index}</span>
						</button>
						{finding.id != null && (<button className="btn cancel-btn" 
							onClick={() => {
								this.props.restoreFinding();
								this.props.setFindingUnderEdit(null);
							}}>ANULUJ<span className='sr-only'> edycje ustalenia nr {index}</span>
						</button>)}
					</div>
				)}
			</div>
		)
	};

	// lista pytań/ustaleń do wyrenderowania
	renderFindings = () => {
		let findings = [];
		this.props.findings.forEach(
			(finding, index) => {
				let findingNumber = this.props.blockNumber + '.' + (index + 1);
				findings.push(this.processFinding(finding, findingNumber))

			}
		);
		return findings

	};

	onDeleteFindingClick = (findingId, findingKey) => {
		this.showPopup('Komunikat', PropertyBucket.deleteFindingConfirmationMessage(), 'confirm', () => {
			this.deleteFinding(findingId, findingKey)
		})
	};

	onDeleteRecommendationClick = (findingId, recommendationId) => {
		this.showPopup('Komunikat', PropertyBucket.deleteRecommendationConfirmationMessage(), 'confirm', () => {
			this.deleteRecommendation(findingId, recommendationId)
		})
	}

	deleteFinding = (findingId, findingPseudoId) => {
		let findings = this.props.findings;
		if (findingId) {
			findings = findings.filter((finding) => findingId !== finding.id);
			this.props.deleteFinding(findingId);
		}
		// New added findings dont have findingId, they use pseudoId instead
		if (findingPseudoId) {
			findings = findings.filter((finding) => findingPseudoId !== finding.pseudoId);
		}
		this.props.onFindingsChange(findings, this.props.blockId, findingId, findingPseudoId);
		this.props.setFindingUnderEdit(null);
	};

	prepareFindingKindOptions = (data) => {
		data.forEach((data) => {
			data.option = data.code + ' ' + data.name;
		})
	};

	renderFindingKindSelect = (value, disabled, findingId, findingPseudoId, index) => {
		let findingKindsDropdown = null;
		let loadedFindingKindsData = this.props.findingKinds;
		this.prepareFindingKindOptions(loadedFindingKindsData);

		if (loadedFindingKindsData.length > 0) {
			findingKindsDropdown = <div id='finding_kind_select' className={this.state.classesFindingKind.join(' ')}>
				<SelectCustom
					values={loadedFindingKindsData.filter(option => option.option === value)}
					labelField='option'
					placeholder='Typ ustalenia'
					valueField='option'
					options={loadedFindingKindsData}
					onChange={(values) => this.setCorrectionTypeValues(values, findingId, findingPseudoId)}
					disabled={disabled}
					id={`findingKindSelectId${index}`}
					dropdownId={`findingKindDropdownId${index}`}
					parentRef={this.findingKindRef}
					label='Typ ustalenia finansowego'
					labelClassName='font-weight-bold'
				/>
			</div>
		}
		return findingKindsDropdown
	};


	render() {
		let popUp;
		if (this.state.showPopup) {
			popUp = <PopUp type={this.state.popUp.type}
			               title={this.state.popUp.title}
			               notification={this.state.popUp.notification}
			               link={this.state.popUp.link}
			               onClickEvent={this.state.popUp.onClickEvent}
			               closePopUp={this.handleClosePopUp}
			/>
		}

		return (<div>
				{popUp}
				{this.renderFindings()}
			</div>
		)
	}

}

export default CreatePostControlInfoFindings
